const dewormingMethods = [
    { value: 'pipette', label: { en: 'Pipette', es: 'Pipeta' } },
    { value: 'collar', label: { en: 'Collar', es: 'Collar' } },
    { value: 'tablet', label: { en: 'Tablet', es: 'Tableta' } },
    { value: 'spray', label: { en: 'Spray', es: 'Spray' } },
];

export default dewormingMethods;